var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",on:{"click":_vm.clickLogo}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("bme")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }